// Module
var code = "<span ng-bind-html=\"$.text | highlightSearch : $.search\"></span>\n";
// Exports
export default code;